import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CartFacade } from './+state';
import { CartStateModule } from './+state/cart.state.module';

import {
  CartFunctionsService,
  CartService
} from './services';

@NgModule({
  imports: [CommonModule, CartStateModule],
})
export class DomainCartModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainCartModule,
      providers: [
        CartService,
        CartFunctionsService,
        CartFacade,
        Storage
      ],
    };
  }
}
